import 'babel-polyfill'

import React from 'react'
import { render } from 'react-dom'
import { browserHistory as history } from 'react-router'
import { AppContainer } from 'react-hot-loader'

import configureStore from '@src/redux/store'
import Root from '@src/Root'
import { FACEBOOK_APP_ID } from '@src/globals'

import { setAuthToken, removeAuthToken } from 'utils/auth'

const isWebpackDevServer = process.env.WEBPACK_DEV_SERVER

// Initialize Raygun error reporting
window.rg4js('apiKey', process.env.RAYGUN_API_KEY)
window.rg4js('enableCrashReporting', true)
window.rg4js('options', {
  debugMode: process.env.NODE_ENV === 'development'
});



// FB initialization
(function (d, s, id) {
  var js
  var fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = `//connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v2.8&appId=${FACEBOOK_APP_ID}`
  fjs.parentNode.insertBefore(js, fjs)
}(document, 'script', 'facebook-jssdk'))

const authToken = window.aliada && window.aliada.jwt
if (authToken) {
  setAuthToken(authToken)
} else if (!isWebpackDevServer) {
  removeAuthToken()
}

// Render app
const store = configureStore(history)
const mountNode = document.getElementById('app')

render(
  <AppContainer>
    <Root
      store={store}
      history={history}
    />
  </AppContainer>,
  mountNode
)

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept('./Root', () => {
      const RootContainer = require('./Root').default
      render(
        <AppContainer>
          <RootContainer
            store={store}
            history={history}
            />
          <div id='fb-root' />
        </AppContainer>,
        document.getElementById('app')
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/index.js